module.exports = __webpack_public_path__ + "img/BannerCompatibilidad600x350.a1caab2b.jpg";